import { useTranslation } from 'react-i18next';

import { BaseIngredientTabProps } from 'components/desktop/BaseIngredient/BaseIngredientComponent';
import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import ItemListEditor from 'components/desktop/_general/ItemListEditor/ItemListEditor';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';
import useCultureCode from 'hooks/redux/useCultureCode';
import * as SeasonList from 'types/_general/Store/SeasonList';

export const BaseIngredientTagsCard = ({
	state,
	handlers,
	data,
}: BaseIngredientTabProps): JSX.Element => {
	const { t } = useTranslation();
	const cultureCode: string = useCultureCode();

	const isBaseIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEBASEINGREDIENT,
	]);

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="baseingredient-tags-card"
			title={t('_general:TAGS')}
			content={
				<>
					<div className="card-body">
						<ItemListEditor
							entityId={state.id}
							allItems={SeasonList.mapToItemList(data.tags)}
							itemIds={state.tagIds}
							setItemIds={handlers.setTagIds}
							readOnly={!isBaseIngredientEditor}
							errorKey="Tags"
							noItemsMessage={t('_general:NO_TAGS')}
							handleAiButtonClick={async () =>
								await handlers.getAndSetSuggestedTags(cultureCode)
							}
						/>
					</div>
				</>
			}
		/>
	);
};
